import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { EditClientComponent } from '../edit-client.component';

export interface EditClientModalData {
	id: string;
}

@Component({
	selector: 'app-edit-modal',
	templateUrl: './edit-modal.component.html',
	standalone: false,
})
export class EditClientModalComponent {
	public id: string;

	constructor(
		public dialogRef: MatDialogRef<EditClientComponent>,
		@Inject(MAT_DIALOG_DATA) public data: EditClientModalData,
	) {
		this.id = data.id;
	}
}
